module.exports = __webpack_public_path__ + "img/doorbC1.65c95d2e.png";